import { Analytics } from './analytics';
import { MedicalConfirmAction } from '../../../other/medicalConfirm/actions/medical_confirm_action';

export class MedicalConfirmNoAnalytics extends Analytics {
  constructor() {
    super();
    MedicalConfirmAction.MEDICAL_CONFIRM_NO_EVENT.on((data) => {
      this.run(() => {
        const linkAnalyticsData = {
          server: 'club/pc',
          fName: '医療施設同意_NO',
          userId: window.analyticsData.userId,
          memberId: window.analyticsData.memberId,
          club: {
            server: 'club/pc',
            prop5: '医療施設同意_NO',
            prop42: window.analyticsData.club.prop42,
            eVar132: window.analyticsData.club.eVar132
          }
        };
        window.sc_trackLinkAll(linkAnalyticsData, data.target, 'o', data.linkName);
      });
    });
  }
}
